import axios from "axios";
import { getBillingUrl } from "../reducers/billing-url.reducer";

export const FETCH_SETTINGS_REQUEST = "FETCH_SETTINGS_REQUEST";
export const FETCH_SETTINGS_SUCCESS = "FETCH_SETTINGS_SUCCESS";
export const FETCH_SETTINGS_FAILURE = "FETCH_SETTINGS_FAILURE";
export const SUBMIT_SETTINGS_REQUEST = "SUBMIT_SETTINGS_REQUEST";
export const SUBMIT_SETTINGS_SUCCESS = "SUBMIT_SETTINGS_SUCCESS";
export const SUBMIT_SETTINGS_FAILURE = "SUBMIT_SETTINGS_FAILURE";
export const INTEGRATE_THEME_REQUEST = "INTEGRATE_THEME_REQUEST";
export const INTEGRATE_THEME_SUCCESS = "INTEGRATE_THEME_SUCCESS";
export const CUSTOM_DOMAIN_REQUEST = "CUSTOM_DOMAIN_REQUEST";
export const CUSTOM_DOMAIN_SUCCESS = "CUSTOM_DOMAIN_SUCCESS";
export const CUSTOM_DOMAIN_ERROR = "CUSTOM_DOMAIN_ERROR";
export const GET_CUSTOM_DOMAIN_REQUEST = "GET_CUSTOM_DOMAIN_REQUEST";
export const GET_CUSTOM_DOMAIN_SUCCESS = "GET_CUSTOM_DOMAIN_SUCCESS";
export const FETCH_SHOP_REVIEW_SETTINGS_REQUEST =
    "FETCH_SHOP_REVIEW_SETTINGS_REQUEST";
export const SUBMIT_SHOP_REVIEW_SETTINGS_REQUEST =
    "SUBMIT_SHOP_REVIEW_SETTINGS_REQUEST";

export const SEND_TEST_MAIL_REQUEST = "SEND_TEST_MAIL_REQUEST";
export const SEND_TEST_MAIL_SUCCESS = "SEND_TEST_MAIL_SUCCESS";

export const SAVE_MAIL_LOGO_REQUEST = "SAVE_MAIL_LOGO_REQUEST";
export const SAVE_MAIL_LOGO_SUCCESS = "SAVE_MAIL_LOGO_SUCCESS";
// const api = axios.create();

export const fetchSettingsRequest = () => {
    return {
        type: FETCH_SETTINGS_REQUEST,
    };
};

export const fetchSettingsSuccess = (settings) => {
    return {
        type: FETCH_SETTINGS_SUCCESS,
        payload: settings,
    };
};

export const fetchSettingsFailure = (error) => {
    return {
        type: FETCH_SETTINGS_FAILURE,
        payload: error,
    };
};

export const submitSettingsRequest = (data) => {
    return {
        type: SUBMIT_SETTINGS_REQUEST,
        payload: { data: data },
    };
};

export const integrateThemeRequest = () => {
    return {
        type: INTEGRATE_THEME_REQUEST,
    };
};

export const submitSettingsSuccess = (settings) => {
    return {
        type: SUBMIT_SETTINGS_SUCCESS,
        payload: settings,
    };
};
export const integrateThemeSuccess = () => {
    return {
        type: INTEGRATE_THEME_SUCCESS,
    };
};

export const customDomainRequest = (data, type) => {
    return {
        type: CUSTOM_DOMAIN_REQUEST,
        payload: { data: data, type: type },
    };
};
export const customDomainSuccess = () => {
    return {
        type: CUSTOM_DOMAIN_SUCCESS,
    };
};

export const customDomaiError = () => {
    return {
        type: CUSTOM_DOMAIN_ERROR,
    };
};

export const getCustomDomainRequest = () => {
    return {
        type: GET_CUSTOM_DOMAIN_REQUEST,
    };
};
export const getCustomDomainSuccess = (data) => {
    return {
        type: GET_CUSTOM_DOMAIN_SUCCESS,
        payload: data,
    };
};

export const submitSettingsFailure = (error) => {
    return {
        type: SUBMIT_SETTINGS_FAILURE,
        payload: error,
    };
};
export const fetchSettings = () => {
    return async (dispatch) => {
        dispatch(fetchSettingsRequest());
        try {
            const response = await axios.get("/settings");
            dispatch(fetchSettingsSuccess(response.data));
        } catch (error) {
            dispatch(fetchSettingsFailure(error.message));
        }
    };
};

export const submitSettings = (data) => {
    return async (dispatch) => {
        dispatch(submitSettingsRequest(data));
        try {
            const element = document.getElementById("app");
            const shop = element.dataset.shop;
            const response = await axios.post("/settings", data);
            if (
                response.data.plan_id &&
                response.data.plan_id != 0 &&
                response.data.plan_id !== null
            ) {
                dispatch(getBillingUrl(response.data.plan_id, shop));
            }
            dispatch(submitSettingsSuccess(response.data));
        } catch (error) {
            dispatch(submitSettingsFailure(error.message));
        }
    };
};

export const fetchShopReviewSettings = () => {
    return async (dispatch) => {
        dispatch(fetchSettingsRequest());
        try {
            const response = await axios.get("/shop-review-settings");
            dispatch(fetchSettingsSuccess(response.data));
        } catch (error) {
            dispatch(fetchSettingsFailure(error.message));
        }
    };
};

export const submitShopReviewSettings = (data) => {
    return async (dispatch) => {
        dispatch(submitSettingsRequest(data));
        try {
            const element = document.getElementById("app");
            const shop = element.dataset.shop;
            const response = await axios.post("/shop-review-settings", data);
            if (
                response.data.plan_id &&
                response.data.plan_id != 0 &&
                response.data.plan_id !== null
            ) {
                dispatch(getBillingUrl(response.data.plan_id, shop));
            }
            dispatch(submitSettingsSuccess(response.data));
        } catch (error) {
            dispatch(submitSettingsFailure(error.message));
        }
    };
};

export const integrateTheme = () => {
    return async (dispatch) => {
        dispatch(integrateThemeRequest());
        try {
            const response = await axios.get("/integrateTheme");
            dispatch(integrateThemeSuccess(response.data));
        } catch (error) {
            // dispatch(submitSettingsFailure(error.message));
        }
    };
};

export const getCustomDomain = (data, type) => {
    console.log("type :: ", type);
    return async (dispatch) => {
        dispatch(customDomainRequest(data, type));
        try {
            const response = await axios.post("/addCustomDomain/" + type, data);

            dispatch(customDomainSuccess(response.data));
        } catch (error) {}
    };
};

export const verifyCustomDomain = () => {
    return async (dispatch) => {
        try {
            const response = await axios.get("/verify-custom-domain");
            dispatch(getCustomDomainSuccess(response.data));
        } catch (error) {
        }
    };
};

export const sendTestEmailForm = (email) => {
    return async (dispatch) => {
        dispatch(sendTestEmailRequest());
        try {
            const response = await axios.get("/sendTestEmail?email=" + email);
            dispatch(sendTestEmailSuccess(response.data));
        } catch (error) {
            // dispatch(submitSettingsFailure(error.message));
        }
    };
};

export const sendTestEmailRequest = () => {
    return {
        type: SEND_TEST_MAIL_REQUEST,
    };
};

export const sendTestEmailSuccess = () => {
    return {
        type: SEND_TEST_MAIL_SUCCESS,
    };
};

export const saveEmailLogo = (data) => {
    return async (dispatch) => {
        dispatch(saveEmailLogoRequest());
        try {
            let formData = new FormData();
            formData.append("logo", data.logo);

            const response = await axios.post(
                "/settings/save-email-logo",
                formData
            );
            dispatch(saveEmailLogoSuccess(response.data));
        } catch (error) {}
    };
};

export const addCustomDomain = (data, type) => {
    console.log("type :: ", type);
    return async (dispatch) => {
        dispatch(customDomainRequest(data, type));
        try {
            const response = await axios.post("/addCustomDomain/" + type, data);

            dispatch(customDomainSuccess(response.data));
        } catch (error) {
            dispatch(customDomaiError());
        }
    };
};

export const saveEmailLogoRequest = () => {
    return {
        type: SAVE_MAIL_LOGO_REQUEST,
    };
};

export const saveEmailLogoSuccess = () => {
    return {
        type: SAVE_MAIL_LOGO_SUCCESS,
    };
};
